export function isWindow(x: unknown): x is Window {
  return x === window;
}
